import styled from 'styled-components';

const FieldGroup = styled.div`
  display: flex;
  margin-top: 8px;

  & > div {
    margin-top: 0;
    padding: 0 8px;
    width: 50%;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
`;

const SpinnerScope = styled.div`
  padding: 103px 0;
  text-align: center;
`;

export default {
  FieldGroup,
  SpinnerScope,
};
